import swal from 'sweetalert2'
import router from '../../router/router'
import store from '../../store/store'
import { tratarErroDoBackParaString, informarErroServidor } from 'src/utils'
import * as Sentry from '@sentry/vue'
import i18n from '../../locales/i18n'
import { ModalDeErroNovoPadrao } from '../gerais'
import config from '@/config'

export const tratarErroDaSincronizacaoEmpregado = (erro, elementoParaFocarAposFecharModal, ehSSO = false) => {
  const erroNovoPadrao = new ModalDeErroNovoPadrao(erro, true)
  // verifica se é no novo padrao
  if (erroNovoPadrao.ehErroTraduzivel) {
    erroNovoPadrao.criarModal()
    return
  }
  // se não for, segue como era antes
  const mensagemDoErro = informarErroServidor.montarMensagemDeErroServidor()
  const codigoDoErro = informarErroServidor.montarCodigoErroServidor('GC', 'SE', erro.status)

  if (erro.status >= 500) {
    swal({type: 'error', text: mensagemDoErro, footer: codigoDoErro})
    return
  }

  if (erro.status === 401 && erro.body?.detail === 'Token expirado') {
    if (ehSSO) {
      store.dispatch('coletor/logarColetorSSO', {})
      return
    }
    store.commit('sincronizador/atribuiErroSincronizarPin', true)
    store.dispatch('coletor/logarColetor', {})
    return
  }

  if (
    (erro.status === 404 && erro.body?.detail.includes('Empregado inválido')) ||
    (erro.status === 400 && erro.body?.detail.includes('Tentantiva de sincronização de empregados não habilitados no coletor')) ||
    (erro.status === 422 && tratarErroDoBackParaString(erro.body?.detail).includes('PIN inválido'))
  ) {
    swal({
      type: 'error',
      text: i18n.t('componentes.sincronizador.utils.modalPinInvalido.texto'),
      onClose: () => {
        if (elementoParaFocarAposFecharModal) { elementoParaFocarAposFecharModal.focus() }
      }
    })
    return
  }

  if (erro.status === 0) {
    const tentativasSincronizacaoPin = store.state.sincronizador.tentativasSincronizacaoPin

    if (tentativasSincronizacaoPin === 3) {
      Sentry.captureEvent({
        message: 'Sincronização-Pin falhou 3 vezes - timeout'
      })
      store.commit('sincronizador/atribuiTentativasSincronizacaoPin', 0)
      swal({
        type: 'error',
        text: mensagemDoErro,
        footer: codigoDoErro,
        allowEnterKey: true,
        showConfirmButton: true,
        confirmButtonText: i18n.t('componentes.sincronizador.utils.botaoConfirmar.texto')
      }).then(result => {
        if (result) {
          if (ehSSO) {
            store.dispatch('sincronizador/fazerSincronizacaoUsuarioSSO', {})
            return
          }
          store.dispatch('sincronizador/fazerSincronizacaoUsuario', {})
        }
      })
      return
    }

    if (tentativasSincronizacaoPin === 2) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoPin', tentativasSincronizacaoPin + 1)
      setTimeout(() => {
        if (ehSSO) {
          store.dispatch('sincronizador/fazerSincronizacaoUsuarioSSO', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
          return
        }
        store.dispatch('sincronizador/fazerSincronizacaoUsuario', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
      }, 2000)
      return
    }

    if (tentativasSincronizacaoPin === 1) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoPin', tentativasSincronizacaoPin + 1)
      setTimeout(() => {
        if (ehSSO) {
          store.dispatch('sincronizador/fazerSincronizacaoUsuarioSSO', { tempoParaFazerRequisicao: 10000 })
          return
        }
        store.dispatch('sincronizador/fazerSincronizacaoUsuario', { tempoParaFazerRequisicao: 10000 })
      }, 2000)
      return
    }

    store.commit('sincronizador/atribuiTentativasSincronizacaoPin', tentativasSincronizacaoPin + 1)
    setTimeout(() => {
      if (ehSSO) {
        store.dispatch('sincronizador/fazerSincronizacaoUsuarioSSO', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
        return
      }
      store.dispatch('sincronizador/fazerSincronizacaoUsuario', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
    }, 2000)
    return
  }

  if (erro.status === 400 && erro.body?.detail === 'Empregado não sincronizado com o REP-P') {
    swal({
      type: 'error',
      html:
        '<b>Empregado não sincronizado com o REP-P.</b><br>' +
        'Verifique se há hoje, uma jornada de férias ou afastamento em sua folha. Caso entenda que é um erro, por favor, entre em contato com o RH da sua empresa.'
    })
    return
  }

  Sentry.captureException(erro.body?.detail || erro)
  swal({
    type: 'error',
    text: tratarErroDoBackParaString(erro.body?.detail)
  })
}

export const tratarErroDaSincronizacaoWeb = (erro, ehSSO = false) => {
  const mensagemDoErro = informarErroServidor.montarMensagemDeErroServidor()
  const codigoDoErro = informarErroServidor.montarCodigoErroServidor('GC', 'SW', erro.status)
  if (erro.status >= 500) {
    swal({type: 'error', text: mensagemDoErro, footer: codigoDoErro})
      .then(result => {
        router.go()
      })
    return
  }

  if (erro.status === 401 && erro.body?.detail === 'Token expirado') {
    if (ehSSO) {
      store.dispatch('coletor/logarColetorSSO', {})
      return
    }

    store.dispatch('coletor/logarColetor', {})
    return
  }

  if (erro.status === 0) {
    const tentativasSincronizacaoWeb = store.state.sincronizador.tentativasSincronizacaoWeb

    if (tentativasSincronizacaoWeb === 3) {
      Sentry.captureEvent({
        message: 'Sincronização-Web falhou 3 vezes - timeout'
      })
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', 0)
      swal({
        type: 'error',
        text: mensagemDoErro,
        footer: codigoDoErro,
        allowEnterKey: true,
        showConfirmButton: true,
        confirmButtonText: i18n.t('componentes.sincronizador.utils.botaoConfirmar.texto')
      }).then(result => {
        if (result) {
          if (ehSSO) {
            store.dispatch('sincronizador/fazerSincronizacaoWebSSO', {})
            return
          }
          store.dispatch('sincronizador/fazerSincronizacaoWeb', {})
        }
      })
      return
    }

    if (tentativasSincronizacaoWeb === 2) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
      setTimeout(() => {
        if (ehSSO) {
          store.dispatch('sincronizador/fazerSincronizacaoWebSSO', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
          return
        }
        store.dispatch('sincronizador/fazerSincronizacaoWeb', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
      }, 2000)
      return
    }

    if (tentativasSincronizacaoWeb === 1) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
      setTimeout(() => {
        if (ehSSO) {
          store.dispatch('sincronizador/fazerSincronizacaoWebSSO', { tempoParaFazerRequisicao: 10000 })
          return
        }
        store.dispatch('sincronizador/fazerSincronizacaoWeb', { tempoParaFazerRequisicao: 10000 })
      }, 2000)
      return
    }

    store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
    setTimeout(() => {
      if (ehSSO) {
        store.dispatch('sincronizador/fazerSincronizacaoWebSSO', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
        return
      }
      store.dispatch('sincronizador/fazerSincronizacaoWeb', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
    }, 2000)
    return
  }

  Sentry.captureException(erro.body?.detail || erro)
  swal({
    type: 'error',
    text: tratarErroDoBackParaString(erro.body?.detail)
  })
}

export const tratarErroDaSincronizacaoWebComTodosOsLocaisEEmpregadores = (erro) => {
  const codigoDoErro = informarErroServidor.montarCodigoErroServidor('GC', 'SW', erro.status)
  const tentativasSincronizacaoWeb = store.state.sincronizador.tentativasSincronizacaoWeb

  if (erro.status >= 500 || erro.status === 0) {
    if (tentativasSincronizacaoWeb === 3) {
      Sentry.captureEvent({
        message: 'Erro ao carregar todos os locais e empregadores na sincronização-web'
      })
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', 0)
      swal({
        type: 'error',
        text: 'Ocorreu um erro ao tentar carregar todos os locais.',
        footer: codigoDoErro,
        allowEnterKey: true,
        showConfirmButton: true,
        confirmButtonText: 'tentar novamente',
        showCancelButton: true,
        cancelButtonText: 'seguir com local de cadastro'
      }).then(result => {
        if (result?.value) {
          store.dispatch('sincronizador/fazerSincronizacaoWebComTodosLocaisEEmpregadores', {})
        }
      })
      return
    }

    if (tentativasSincronizacaoWeb === 2) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
      store.dispatch('sincronizador/fazerSincronizacaoWebComTodosLocaisEEmpregadores', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
      return
    }

    if (tentativasSincronizacaoWeb === 1) {
      store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
      store.dispatch('sincronizador/fazerSincronizacaoWebComTodosLocaisEEmpregadores', { tempoParaFazerRequisicao: 10000 })
      return
    }

    store.commit('sincronizador/atribuiTentativasSincronizacaoWeb', tentativasSincronizacaoWeb + 1)
    store.dispatch('sincronizador/fazerSincronizacaoWebComTodosLocaisEEmpregadores', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
    return
  }

  swal({
    type: 'error',
    text: 'Ocorreu um erro ao tentar carregar todos os locais.',
    footer: codigoDoErro,
    allowEnterKey: true,
    showConfirmButton: true,
    confirmButtonText: 'seguir com local de cadastro'
  })
  Sentry.captureException(erro)
}
